/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class LevelService  {
  levels: any[];
  onLevelChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getLevels()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getLevels () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/eventLevel/eventLevels'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.levels = response;
          this.onLevelChanged.next(this.levels);
          resolve(response);
        }, reject);
    });

  }

  getEventLevelById(id) {
    return this.http.get(this.api.baseUrl + '/eventLevel/eventLevel?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteEventLevel(id) {
    return this.http.delete(this.api.baseUrl + '/eventLevel/deleteEventLevel?id=' + id , this.api.jsonTokenHeaders);
  }

  addEventLevel(data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[key]) {
        formData.append(key, data[key]);
      }
    }
    return this.http.post(this.api.baseUrl + '/eventLevel/addEventLevel' , formData , this.api.formDataHeaders);
  }
}
